import React, {Component} from 'react';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import DateSinceFilter from '../components/DateSinceFilter';
import MissingScansTable from '../components/MissingScansTable';
import Avatar from 'material-ui/Avatar';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import Icon from 'material-ui/svg-icons/alert/error-outline';

export class MissingScansList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listComplete: false,
            loading: false,
            startDate: null,
            startDateStr: ''
        };
    }

    handleFilterSubmit = (value) => {
        if (value) {
            const date = new Date(value);
            const str = date.getUTCMonth() + 1 + '/' + date.getUTCDate() + '/' + date.getUTCFullYear();
            this.setState({
                listComplete: false,
                loading: true,
                startDate: value,
                startDateStr: str
            });
        }
    };

    handleListComplete = (isComplete) => {
        this.setState({
            listComplete: isComplete,
            loading: false
        });
    };

    render() {
        const {
            listComplete,
            loading,
            startDate,
            startDateStr
        } = this.state;

        const ListTitle = <span className="list-title">
            <Avatar icon={<Icon/>} className="avatar-title"/>Missing Scans</span>;

        const ListDescription = () => {
            return (
                <span>
                    <p>Occasionally Products will have barcodes that are not recognized by the system, because
                        the Product does not yet exist, an Alias for the Product is needed, or the Product is
                        not sold by this store.</p>
                    <p>Search by year and month below to view missing items.</p>
                </span>
            );
        };

        return (
            <div className="list-container">
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        <DateSinceFilter
                            labelInput="Select Date Since"
                            labelSubmit="Search Scans"
                            loading={loading}
                            onSubmitDate={this.handleFilterSubmit}
                        />

                        {startDate &&
                            <div>
                                <h3>
                                    Missing Scans since {startDateStr}
                                </h3>

                                {!listComplete &&
                                    <div className="loader-container">
                                        <h4>Searching Scans...</h4>
                                        <CircularProgress
                                            size={24}
                                            thickness={2}
                                            className="loader"
                                        />
                                    </div>
                                }

                                {/* Missing Scans Table */}
                                <MissingScansTable
                                    startDate={startDate}
                                    listComplete={listComplete}
                                    onDataComplete={this.handleListComplete}
                                />
                            </div>
                        }
                    </CardText>

                </Card>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Fuse/Inventory/MissingScansList.js